<template>
    <div class="relative flex flex-col items-start w-full font-sans  bg-white pt-3 md:pl-8 pb-5 md:pr-4 rounded-lg">
        <div class="mb-6">
            <div class="text-base md:text-xl font-bold text-brand-light">Шаг 4. <span class="text-main-text">Управление афишами в игре</span></div>
            <div class="text-10px md:text-sm font-bold text-additional-text mt-2">Разместите афишу в нужном месте или поменяйте порядок афиш</div>
        </div>
        <div class="flex flex-col w-full  overflow-x-auto bems-scroller scroll-panel" id="scrolling-container">
            <div class="flex flex-col mb-6 ml-1 md:ml-2 "  >
                <div class="flex flex-row items-start" :key="key" v-for="(tour, key) in gameStr"
                     v-if="f.length > 0 && gameStr.length > 0">
                    <div class="flex flex-col justify-start">
                        <div v-if="tour.type === 'custom'">
                            <div class="flex flex-row" v-for="(item, itemKey) in tour.items" :key="itemKey">
                                <div class="relative items-center flex flex-row">
                                    <div class="h-full w-1 border-r border-additional-text"></div>
                                    <div class="border w-2 h-2 border-additional-text bg-white rounded absolute" style="margin-left: -0.05rem"></div>
                                </div>
                                <div class="w-48 flex items-center text-additional-text py-6 text-xs font-bold ml-5">
                                    <div>{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row" v-else>
                            <div v-if="key !== 0" class="relative items-center flex flex-row">
                                <div class="h-full w-1 border-r border-additional-text"></div>
                                <div class="border w-2 h-2 border-additional-text bg-white rounded absolute" style="margin-left: -0.05rem"></div>
                            </div>
                            <div class="">
                                <div v-if="key === 0" class="font-bold pb-4 text-main-text">
                                    <div>{{tour.name}}</div>
                                </div>
                                <div v-if="key !== 0"
                                     class="w-48 flex items-center text-additional-text py-6 text-xs font-bold ml-5">
                                  <div v-if="(tour.items[0]) && (tour.type !== 'tour')">{{tour.items[0].name}}</div>
                                  <div v-else>{{tour.name}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row">
                            <div class="relative items-center flex flex-row">
                                <div v-if="key === 0" class="h-1/2 w-1 border-r border-additional-text -mb-5"></div>
                                <div v-if="key === Object.keys(gameStr).length - 1" class="h-1/2 w-1 border-r border-additional-text -mt-5"></div>
                                <div v-if="key !== 0 && key !== (Object.keys(gameStr).length - 1)" class="h-full w-1 border-r border-additional-text"></div>
                                <div class="border w-3 h-3 border-additional-text bg-brand-yellow rounded-full absolute" style="margin-left: -0.1rem"></div>
                            </div>
                            <div class="flex flex-row justify-start items-center ml-5">
                                <div :key="id" v-for="(slide, id) in f[key].advertisements" class="flex">
                                    <plus-box :advertisement="advertisement" :place="tour.id" :slide="slide"
                                              @add="addAdvertisement" @removed="removeAdvertisement"
                                              class="text-black rounded-lg mr-3 md:mr-8"></plus-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input @input="onScrollBarChange" class="scroll-range sticky hidden md:block" :class="{'hidden' : hidden}" id="scroll-range" type="range"/>
    </div>
</template>

<script>
import uuid from 'uuid/v4';
import client from '@/clients/partners';
import Form from 'form-backend-validation';
import Selectbox from '../../../selectbox.vue';
import PlusBox from '../../../plus-box.vue';

export default {
  name: 'step4',
  components: { PlusBox, Selectbox },
  props: ['advertisement', 'advertisementOrder', 'game_type_id', 'game_topic_id', 'eventUuid', 'gameTypes', 'showHeader'],
  data() {
    return {
      allAdvertisements: this.advertisement,
      selectedTypeGame: 'Выбрать тип игры',
      form: new Form({
        advertisementOrder: [],
      }, { http: client }),
      gameStructure: [],
      city_id: '',
      t: [],
      f: [],
      gameStr: [],
      typeAdvertisement: {
        'mozgo-party': 'Mozgoparty',
        instagram: 'Инстаграм-конкурс',
        vk: 'Vk-конкурс',
        corporate: 'Корпоративные игры',
        partners: 'Покупка франшизы',
        'next-game': 'Следующая игра',
        free: 'Свободная афиша',
      },
      hidden: true,
    };
  },
  created() {
    // console.log(this.form);
    this.city_id = this.$store.getters.userInfo.city_id;
    client.get(`/game-templates/animations?game_type_id=${this.game_type_id || ''}&game_topic_id=${this.game_topic_id || ''}&city_id=${this.city_id}`)
      .then((data) => {
        this.gameStructure = data.data;
        if (this.advertisementOrder) {
          this.$set(this.form, 'advertisementOrder', this.advertisementOrder);
          this.getStructure('1');
        }
        if (this.form.advertisementOrder.length === 0) {
          this.gameStructure.forEach((item) => {
            this.createEmptyRow(item);
          });
          this.getStructure('2');
        }
      });
  },
  methods: {
    getStructure(value) {
      this.form.advertisementOrder.forEach((item, key) => {
        if (item.id !== 'advertisement') {
          this.t.push(key);
        }
        if (value === '2') {
          if (item.id === 'advertisement') {
            // this.form.advertisementOrder[key-1].advertisements = [];
            this.advertisement.forEach((advert, id) => {
              const adv = { id: uuid(), advertisement_id: advert.id, name: advert.type };
              this.form.advertisementOrder[key - 1].advertisements.push(adv);
            });
            this.removeAdvertisement(this.form.advertisementOrder[key - 1].id, this.form.advertisementOrder[key - 1].advertisements[0].id);
            this.createBox(this.form.advertisementOrder[key - 1], uuid(), null, '');
          }
        }
      });
      this.t.forEach((item) => {
        this.gameStr.push(this.gameStructure[item]);
        this.f.push(this.form.advertisementOrder[item]);
      });
    },
    addAdvertisement(place, id, option, advertisement_id) {
      this.form.advertisementOrder.forEach((item) => {
        if (item.id === place) {
          item.advertisements.forEach((i) => {
            if (i.id === id) {
              if (i.advertisement_id === null) this.createBox(item, uuid(), null, '');
              i.name = option;
              i.advertisement_id = advertisement_id;
            }
          });
        }
      });
    },
    removeAdvertisement(place, id) {
      this.form.advertisementOrder.forEach((item) => {
        if (item.id === place) {
          item.advertisements = item.advertisements.filter(i => i.id !== id);
        }
      });
    },
    createEmptyRow(item) {
      this.form.advertisementOrder.push({
        id: item.id,
        advertisements: [],
      });
      this.createBox(this.form.advertisementOrder[this.form.advertisementOrder.length - 1], uuid(), null, '');
    },
    createBox(item, id, advertisement_id, name) {
      item.advertisements.push({
        id,
        advertisement_id,
        name,
      });
    },
    async validate() {
      const savedData = this.form.data();
      this.$emit('changedGamesStore', savedData);
    },

    onScrollBarChange(event) {
      const panel = document.getElementById('scrolling-container');

      const total = panel.scrollWidth - panel.offsetWidth;

      const percentage = total * (event.target.value / 100);


      panel.scrollLeft = percentage;
    },


  },


  updated() {
    console.log('upd');
    const elem = document.getElementById('scrolling-container');
    const offset = elem.offsetWidth;
    const scroll = elem.scrollWidth;
    this.hidden = (scroll - offset) < 1;

    /* if (!this.hidden) {
        const scroll = document.getElementById("scroll-range");
        const width  = (offset / scroll);
       // const thumb = document.querySelector('input::-webkit-slider-thumb');

        //console.dir(thumb);
        console.dir(scroll);
        scroll.style["-webkit-slider-thumb"].width = width * scroll.width;
        console.dir(scroll);
      } */
  },

};
</script>

<style scoped>
    ::-webkit-scrollbar {
        margin-right: 20%;
        height: 10px; /* height of horizontal scrollbar ← You're missing this */
        width: 10px; /* width of vertical scrollbar */
        border: 20px solid #d5d5d5;
        border-radius: 10px;
        position: sticky;
        bottom: 0;

    }

    ::-webkit-scrollbar-thumb {
        background-color: #bd006c;
        border: 0px solid transparent;
        border-radius: 9px;
        height: 15px;
        background-clip: content-box;

    }

    .hidden {
      display: hidden;
    }


 #scrolling-container {

  overflow-x: -moz-scrollbars-none;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style:-ms-autohiding-scrollbar;
}

#scrolling-container::-webkit-scrollbar {
  display: none;
}


.rangeslider {
  margin: 0 auto;
  padding: 20px 0;
  width: 500px;
}
input[type="range"] {
  background: rgb(190, 190, 190);
  height: 10px;
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  border-radius: 3px;
  bottom: 10px;
}
input[type="range"]:focus {
  outline: none;
}
.rangeslider,
input::-webkit-slider-thumb {
  background: #bd006c;
  cursor: pointer;
  border-radius: 9px;
        height: 15px;
  text-indent: -9999px;
  width:20%;
  box-shadow: 0 3px 6px rgba(0,0,0,0.3), 0 1px 0 rgba(255,255,255,0.2) inset;
  -moz-appearance: none;
  -webkit-appearance: none;
  border-radius: 10px;
}
@media (max-width: 640px) {
  #scrolling-container::-webkit-scrollbar {
  display: block
}
}

</style>
